(()=>{
'use strict';
const VERSION='2.0.0';
const HANDOFF_KEY='flayvr_ami_full_profile_handoff_v1';
const ARM_KEY='flayvr_ami_full_profile_autostart_v1';
const AMI_KEY='flayvr_ami_final_v27';
const LEGACY_AMI_KEYS=['flayvr_ami_final_v26','flayvr_ami_final_v2114','flayvr:ami-ai-chatbot:v8','flayvr:ami-ai-chatbot:v7','flayvr:ami-ai-chatbot:v6','flayvr:ami-ai-chatbot:v5','flayvr:ami-ai-chatbot:v4','flayvr:ami-ai-chatbot:v3'];
const MAX_AGE=7*24*60*60*1000;
const ARCH=['explorer','tastemaker','purist','classic'];
const ARCH_NAMES={explorer:'The Explorer',tastemaker:'The Tastemaker',purist:'The Purist',classic:'The Classic'};
const CITIES=['','London','Manchester','Birmingham','Edinburgh','Bristol','Glasgow','Leeds','Liverpool'];
const clamp=n=>Math.max(0,Math.min(100,Math.round(Number(n)||0)));
const clean=s=>String(s??'').replace(/\s+/g,' ').trim();
function jsonGet(key,fallback=null){try{const v=JSON.parse(localStorage.getItem(key)||'null');return v==null?fallback:v}catch(e){return fallback}}
function b64bytes(token){let s=String(token||'').replace(/-/g,'+').replace(/_/g,'/');while(s.length%4)s+='=';const raw=atob(s),a=new Uint8Array(raw.length);for(let i=0;i<raw.length;i++)a[i]=raw.charCodeAt(i);return a}
function decodeProfile(token){
  try{
    const a=b64bytes(token);if(a.length<9)return null;
    if(a[0]===4&&a[1]<4){const len=a[9];if(a.length!==11+len)return null;let check=0;for(let i=0;i<a.length-1;i++)check^=a[i];if(check!==a[a.length-1])return null;let firstName='';try{firstName=new TextDecoder().decode(a.slice(10,10+len))}catch(e){};return {key:ARCH[a[1]],name:ARCH_NAMES[ARCH[a[1]]],firstName,adv:a[2],heat:a[3],intensity:a[4],acid:a[5],texture:a[6],sweet:a[7],city:CITIES[a[8]]||''}}
    if(a[0]===3&&a.length===10&&a[1]<4){let check=0;for(let i=0;i<9;i++)check^=a[i];if(check!==a[9])return null;return {key:ARCH[a[1]],name:ARCH_NAMES[ARCH[a[1]]],firstName:'',adv:a[2],heat:a[3],intensity:a[4],acid:a[5],texture:a[6],sweet:a[7],city:CITIES[a[8]]||''}}
    if(a[0]===2&&a.length===9&&a[1]<4){let check=0;for(let i=0;i<8;i++)check^=a[i];if(check!==a[8])return null;return {key:ARCH[a[1]],name:ARCH_NAMES[ARCH[a[1]]],firstName:'',adv:a[2],heat:a[3],intensity:a[4],acid:a[5],texture:a[6],sweet:a[7],city:''}}
  }catch(e){}
  return null;
}
function decodeDining(token){try{const a=b64bytes(token);if(a.length!==7||a[0]!==2)return null;let c=0;for(let i=0;i<6;i++)c^=a[i];if(c!==a[6])return null;return {menu:a[1],energy:a[2],theatre:a[3],formal:a[4],travel:a[5]}}catch(e){return null}}
function diningArchetype(d){if(!d)return 'Balanced & flexible';if(d.menu>70&&d.theatre>65&&d.formal<65)return 'Immersive, not stiff';if(d.formal>70)return 'Occasion-led';if(d.energy<40)return 'Quietly ambitious';if(d.energy>75&&d.theatre>75)return 'High-energy explorer';return 'Balanced & flexible'}
function fromUrl(){
  const u=new URL(location.href);if(u.searchParams.get('from')!=='full-profile')return null;
  const profile=decodeProfile(u.searchParams.get('p')||''),dining=decodeDining(u.searchParams.get('fp')||'');if(!profile||!dining)return null;
  return {v:1,source:'full-taste-profile-link',createdAt:Date.now(),completedAt:Date.now(),profile,dining,insights:{archetype:diningArchetype(dining),brief:'',tension:''},fullProfileUrl:'',menuUrl:location.href};
}
function stored(){const h=jsonGet(HANDOFF_KEY,null);if(!h||typeof h!=='object')return null;const at=Number(h.createdAt||h.completedAt||0);if(at&&Date.now()-at>MAX_AGE)return null;return h}
function baseline(p){return p&&['adv','heat','intensity','acid','texture','sweet'].every(k=>Number.isFinite(Number(p[k])))}
function sameProfile(a,b){if(!baseline(a)||!baseline(b))return false;return ['adv','heat','intensity','acid','texture','sweet'].every(k=>Math.abs(Number(a[k])-Number(b[k]))<=1)}
function existingAmiRecord(){
  for(const key of [AMI_KEY,...LEGACY_AMI_KEYS]){const row=jsonGet(key,null);if(row&&typeof row==='object')return row}
  return null;
}
function seedAmi(h){
  const existing=existingAmiRecord()||{},raw=existing.state&&typeof existing.state==='object'?{...existing.state}:{...existing};
  const p=h?.profile||{};
  if(clean(p.firstName))raw.name=clean(p.firstName).split(/\s+/)[0].slice(0,50);
  let completed=Array.isArray(raw.completed)?raw.completed.slice():Array.isArray(existing.completedSteps)?existing.completedSteps.slice():[];
  if(raw.name&&!completed.includes('name'))completed.push('name');
  raw.completed=completed;
  raw.menu=[];
  raw.currentStepId='';
  raw.editingCoverage=false;
  try{localStorage.setItem(AMI_KEY,JSON.stringify({state:raw,savedAt:Date.now(),version:'full-profile-handoff-'+VERSION}))}catch(e){}
}
function topSignals(p){
  const labels={adv:'adventure',heat:'heat',intensity:'intensity',acid:'acid',texture:'texture',sweet:'sweetness'};
  return Object.entries(labels).map(([k,label])=>[label,Number(p?.[k])||0]).sort((a,b)=>b[1]-a[1]).slice(0,3).map(x=>x[0]);
}
function phrase(items){items=(items||[]).filter(Boolean);if(items.length<2)return items[0]||'';if(items.length===2)return items[0]+' and '+items[1];return items.slice(0,-1).join(', ')+' and '+items[items.length-1]}
function acknowledgement(h){
  const p=h?.profile||{},d=h?.dining||{},ins=h?.insights||{};
  const first=clean(p.firstName),name=clean(p.name)||'your Taste Profile',signals=topSignals(p),style=clean(ins.archetype)||diningArchetype(d);
  return `I’ve got your Full Taste Profile${first?', '+first:''}. ${name} is led by ${phrase(signals)}. Your dining style is ${style}. I’ll use the Taste signals to shape the food and keep the rest as context, so I only need anything your profile didn’t cover.`;
}
function activeHandoff(){
  const u=new URL(location.href),armed=Boolean(jsonGet(ARM_KEY,null)),urlActive=u.searchParams.get('from')==='full-profile';
  if(!armed&&!urlActive)return null;
  const urlH=fromUrl(),local=stored();
  if(urlH&&local&&sameProfile(urlH.profile,local.profile))return local;
  return urlH||local;
}
const handoff=activeHandoff();
if(!handoff)return;
window.FlayvrAmiFullProfile=handoff;
seedAmi(handoff);
try{localStorage.removeItem(ARM_KEY)}catch(e){}
function waitForApi(timeout=8000){return new Promise(resolve=>{const start=Date.now();(function tick(){if(window.FlayvrAmi?.open)return resolve(window.FlayvrAmi);if(Date.now()-start>=timeout)return resolve(null);setTimeout(tick,40)})()})}
function findChoice(text){return [...document.querySelectorAll('.flami-choice')].find(b=>clean(b.textContent).toLowerCase()===text.toLowerCase())}
function replaceFirstAmiBubble(copy){
  const bubble=document.querySelector('[data-flayvr-ami-v27] .flami-msg--ami .flami-bubble');if(!bubble)return false;bubble.textContent=copy;return true;
}
function cleanUrl(){try{const u=new URL(location.href);['from','p','fp'].forEach(k=>u.searchParams.delete(k));history.replaceState(history.state,'',u.pathname+(u.searchParams.toString()?'?'+u.searchParams.toString():'')+u.hash)}catch(e){}}
async function postBoot(){
  const api=await waitForApi();if(!api)return;
  api.open();
  if(typeof api.resumeFullProfile==='function'){
    api.resumeFullProfile(handoff);
    cleanUrl();
    return;
  }
  const copy=acknowledgement(handoff);
  const start=Date.now();
  const resumeTimer=setInterval(()=>{
    const btn=findChoice('Continue my plan');
    if(btn){clearInterval(resumeTimer);btn.click();setTimeout(()=>replaceFirstAmiBubble(copy),80);setTimeout(()=>replaceFirstAmiBubble(copy),260);setTimeout(()=>replaceFirstAmiBubble(copy),620);cleanUrl();return}
    if(Date.now()-start>3000){clearInterval(resumeTimer);replaceFirstAmiBubble(copy);cleanUrl()}
  },40);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',postBoot,{once:true});else postBoot();
})();
